import BaseAction from '@/actions/base_action.js'

export default class extends BaseAction {
  execute(spec, component) {
    const hillChart = GLib.component.findById('hill_chart')
    hillChart.clearBringToFront()
    hillChart.bringToFront(spec.scopeCardId)
  }
}
